module.exports = __webpack_public_path__ + "img/right3 (1).7ddcb998.png";